import Cookies from 'js-cookie';
import {
  WOOCOMMERCE_SBJS_CURRENT_ADD_COOKIE_KEY,
  WOOCOMMERCE_SBJS_CURRENT_COOKIE_KEY,
  WOOCOMMERCE_SBJS_FIRST_ADD_COOKIE_KEY,
  WOOCOMMERCE_SBJS_FIRST_COOKIE_KEY,
  WOOCOMMERCE_SBJS_MIGRATIONS_COOKIE_KEY,
  WOOCOMMERCE_SBJS_SESSION_COOKIE_KEY,
  WOOCOMMERCE_SBJS_UDATA_COOKIE_KEY,
} from '../constants';

export const getWooCommerceUtmCookie = () => {
  const sbjsCurrent = Cookies.get(WOOCOMMERCE_SBJS_CURRENT_COOKIE_KEY);
  const sbjsCurrentAdd = Cookies.get(WOOCOMMERCE_SBJS_CURRENT_ADD_COOKIE_KEY);
  const sbjsSession = Cookies.get(WOOCOMMERCE_SBJS_SESSION_COOKIE_KEY);
  const sbjsUdata = Cookies.get(WOOCOMMERCE_SBJS_UDATA_COOKIE_KEY);
  const sbjsFirst = Cookies.get(WOOCOMMERCE_SBJS_FIRST_COOKIE_KEY);
  const sbjsFirstAdd = Cookies.get(WOOCOMMERCE_SBJS_FIRST_ADD_COOKIE_KEY);
  const sbjsMigrations = Cookies.get(WOOCOMMERCE_SBJS_MIGRATIONS_COOKIE_KEY);

  return { sbjsCurrent, sbjsCurrentAdd, sbjsSession, sbjsUdata, sbjsFirst, sbjsFirstAdd, sbjsMigrations };
};
